import axios from '../utils/axios'

// 合伙人页面信息
export function PartnerInfoGet (params = {}) {
  return axios({
    url: '/Member/SApp/PartnerInfoGet',
    method: 'GET',
    params: params
  })
}
// 获得推荐提成配置接口
export function CommissionAmount (params = {}) {
  return axios({
    url: '/NoAuth/SaleIndex/CommissionAmount',
    method: 'GET',
    params: params
  })
}
// 合伙人提成接口
export function PartnerAmountToFinance (params = {}) {
  return axios({
    url: '/Member/SApp/PartnerAmountToFinance',
    method: 'POST',
    params: params
  })
}
// 推荐好友列表
export function MSappListByPartnerCode (params = {}) {
  return axios({
    url: '/Member/RecommendCycle/MSappListByPartnerCode',
    method: 'GET',
    params: params
  })
}
// 已注册好友列表
export function RecommendRegisterList (params = {}) {
  return axios({
    url: '/Member/RecommendCycle/RecommendRegisterList',
    method: 'GET',
    params: params
  })
}
// 提成明细
export function MyConcessionInfo (params = {}) {
  return axios({
    url: '/Member/SApp/MyConcessionInfo',
    method: 'GET',
    params: params
  })
}
